import { v4 } from 'uuid';
import { getCookie } from './getCookie.js';
import { setCookie } from './setCookie.js';

var SESSION_ID_EXPIRATION = 10 * 60 * 1000;
var SESSION_ID_COOKIE_KEY = 'fusra_session_id';
function getSessionId() {
  var sessionId = getCookie(SESSION_ID_COOKIE_KEY);
  if (!sessionId) {
    sessionId = v4();
  }
  setCookie(SESSION_ID_COOKIE_KEY, sessionId, SESSION_ID_EXPIRATION);
  return sessionId;
}

export { getSessionId };
